<template>
  <div>
    <div class="grid bg-white">
      <div class="grid-title">
        <h4>Transactions ( {{ account.account_name }} )</h4>
      </div>
      <div class="grid-body">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>#</th>
              <th>Invoice No.</th>
              <th>PREPAID BY</th>
              <th>PAYMENT REF. NO.</th>
              <th>PAYMENT DATE TIME</th>
              <th>COST BELONG TO</th>
              <th>Amount</th>
              <th>Account Balance</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(tran, index) in trans" :key="tran.id">
              <td>
                {{ index + 1 }}
              </td>
              <td>
                {{ tran.invoice.invoice_number }}
              </td>
              <td>
                {{ tran.invoice.prepaid_by }}
              </td>
              <td>
                {{ tran.invoice.transaction_reference_number }}
              </td>
              <td class="text-center">
                {{
                  moment(tran.invoice.transaction_date_time).format(
                    "DD MMM, YYYY"
                  )
                }}
              </td>
              <td class="text-center">
                {{ moment(tran.invoice.cost_belong_to).format("YYYY, MMM") }}
              </td>
              <td class="text-right">
                <span class="text-danger" v-if="tran.debit == 0">
                  - {{ ezy.comma(tran.credit) }}</span
                >
                <span class="text-success" v-else>
                  {{ ezy.comma(tran.debit) }}
                </span>
              </td>
              <td class="text-right">
                {{ ezy.comma(tran.account_balance) }}
              </td>
            </tr>

            <tr v-if="loading">
              <td class="text-center" colspan="8">
                <i class="fa fa-circle-o-notch fa-spin" aria-hidden="true"></i>
                Loading ...
              </td>
            </tr>
            <tr v-if="noMoreData">
              <td class="text-center" colspan="8">No More Data</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import account from "./Classes/account";
import ezy from "./Tools/ezyFunction";
import moment from "moment";
export default {
  data() {
    return {
      trans: [],
      account: {},
      ezy,
      moment,
      params: {
        limit: 30,
        page: 1,
      },
      canScroll: false,
      loading: false,
      noMoreData: false,
    };
  },
  watch: {
    $route() {
      this.trans = [];
      this.params = {
        limit: 30,
        page: 1,
      };
      this.canScroll = false;
      this.loading = false;
      this.loading = false;
      this.getTrans();
    },
  },
  mounted() {
    this.getTrans();
    this.scroll();
  },
  methods: {
    async getTrans() {
      this.loading = true;
      let res = await account.getTrans(this.$route.params.id, this.params);
      if (res) {
        this.account = res.account;
        let trans = res.trans;
        trans.forEach((val) => {
          this.trans.push(val);
        });
        if (trans.length < this.params.limit) {
          this.canScroll = false;
          this.noMoreData = true;
        } else {
          this.params.page++;
          this.canScroll = true;
          this.noMoreData = false;
        }
        this.loading = false;
      }
    },
    scroll() {
      var self = this;
      window.onscroll = () => {
        var elem = document.getElementsByClassName("page-content")[0];
        if (self.canScroll == true && self.noMoreData == false) {
          if (
            document.documentElement.scrollTop +
              document.documentElement.offsetHeight >=
            elem.scrollHeight
          ) {
            self.canScroll = false;
            self.getTrans();
          }
        }
      };
    },
  },
};
</script>
